<template>
  <Card class="p-4 border-b-4 border-h-primary-800 custom-card mt-4">
    <template #header>
      <h6 class="px-">Item {{ itemIndex + 1 }}</h6>
    </template>

    <template #content>
      <p class="flex flex-wrap w-full" v-html="item?.getHTML()"></p>
    </template>
    <template #footer>
      <span class="flex flex-row-reverse w-full">
        <Button
          :id="`card-item-edit-btn`"
          class="btn-simple w-fit !p-0 !px-2"
          @click="onEdit()"
        >
          <v-icon name="hi-solid-pencil" />
          <p>{{ $t("labels.edit") }}</p>
        </Button>
        <Button class="btn-delete w-fit" @click="confirmDeleteModal()">
          <v-icon name="md-delete" />
          <p>{{ $t("labels.delete") }}</p>
        </Button>
      </span>
    </template>
  </Card>
  <ConfirmDialog
    :group="`item-card-${itemIndex}`"
    class="custom-dialog"
    :draggable="false"
    :style="{ width: '80vw', maxWidth: '700px' }"
  />
  
</template>
<script lang="ts">
import { useQuizQuestionsDragNDropStore } from "@/store/quiz-question-drag";
import { defineComponent } from "vue";

export default defineComponent({
  name: "item-card",
  emits: ["editItem"],
  data() {
    return {
      questionStore: useQuizQuestionsDragNDropStore,
    };
  },
  props: {
    item: Object,
    itemIndex: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    onEdit() {
      this.$emit("editItem", this.itemIndex);
    },
    onDelete() {
      this.questionStore.items.splice(this.itemIndex, 1);
      this.questionStore.responses = this.questionStore.responses.filter(
        (response) => response.itemGroup !== this.itemIndex
      );
      this.questionStore.responses.map((response) => {
        if (response.itemGroup >= this.itemIndex + 1) {
          response.itemGroup--;
        }
      });
    },
    confirmDeleteModal(): void {
      this.$confirm.require({
        group: `item-card-${this.itemIndex}`,
        message: this.$t("labels.generic", {
          pt: "Deseja deletar este item?",
          en: "Do you want to delete this item?",
        }),
        header: this.$t("labels.generic", {
          pt: "Deletar item",
          en: "Delete item",
        }),
        acceptLabel: this.$t("labels.generic", { pt: "Sim", en: "Yes" }),
        rejectLabel: this.$t("labels.generic", { pt: "Não", en: "No" }),
        rejectClass: "btn-simple",
        acceptClass: "btn-delete-block",
        accept: () => {
          this.onDelete();
        },
      });
    },
  },
});
</script>
<style lang="scss">
.custom-card {
  .p-card-body,
  .p-card-footer {
    padding: 0 !important;
  }
  span {
    word-break: break-all;
    line-height: 175%;
  }

  .mention {
    background-color: #f6fafd;
    border-radius: 0.4rem;
    border: 1px solid #79b5e1;
    box-decoration-break: clone;
    color: #79b5e1;
    padding: 0.1rem 0.3rem;
    word-wrap: break-all;
  }
  .p-component {
    word-break: break-all;
  }
}
.custom-dialog {
  .p-dialog-content {
    min-height: 100px;
    min-width: 300px;
  }
}
</style>
